import type { ComponentSingleStyleConfig } from "@chakra-ui/react"

export const Tooltip: ComponentSingleStyleConfig = {
  baseStyle: {
    bg: "surfaceInverseAlt",
    color: "textInverse",
    borderRadius: "sm",
    fontSize: "xs",
    fontWeight: "normal",
    px: "3",
    py: "2",
    "--popper-arrow-bg": "colors.surfaceInverseAlt",
  },
}
